"use strict";
/*
 * Created on 29/08/2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var ProductSuppliers_1 = require("../../supply/model/ProductSuppliers");

var ProductSuppliersGroup_1 = require("../../supply/model/ProductSuppliersGroup");

var Product_1 = require("./Product");
/**
 * FindWindowProductsDTO
 *
 * @author Tomáš Leity
 * @deprecated use SuppliedProduct aggregated entities
 */


var FindWindowProductsDTO =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(FindWindowProductsDTO, _DomainObject_1$Domai);

  /**
   * Constructs FindWindowProductsDTO instance.
   *
   * @param products
   * @param productIds
   * @param categoryIds
   * @param suppliers
   * @param supplierIds
   * @param supplierGroups
   */
  function FindWindowProductsDTO(products, productIds, categoryIds, suppliers, supplierIds) {
    var _this;

    var supplierGroups = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : immutable_1.List.of();

    _classCallCheck(this, FindWindowProductsDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FindWindowProductsDTO).call(this));
    _this.products = products;
    _this.productIds = productIds;
    _this.categoryIds = categoryIds;
    _this.suppliers = suppliers;
    _this.supplierIds = supplierIds;
    _this.supplierGroups = supplierGroups;
    return _this;
  }

  return FindWindowProductsDTO;
}(DomainObject_1.DomainObject);

exports.FindWindowProductsDTO = FindWindowProductsDTO;

FindWindowProductsDTO.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(FindWindowProductsDTO.name);
  return {
    products: builder.listOf(builder.obj('products', Product_1.Product.schema, function (mat) {
      return new Product_1.Product(mat.id, mat.externalId, mat.numericId, mat.name, mat.familyId, mat.description, mat.eans, mat.categoryIds, mat.productSensitivityId, mat.tierId, mat.flags, mat.calibratedProductId, mat.predecessorId, mat.classification, mat.dimensions, mat.expiration, mat.supplierId, mat.supplierIds, mat.active, mat.measureUnitId, mat.packageSize, mat.numberOfProductBindings, mat.newlyListedIntervalStart, mat.newlyListedIntervalEnd);
    })),
    productIds: builder.listOf(builder.str('productIds')),
    categoryIds: builder.listOf(builder.str('categoryIds')),
    suppliers: builder.listOf(builder.obj('suppliers', ProductSuppliers_1.ProductSuppliers.schema, function (mat) {
      return new ProductSuppliers_1.ProductSuppliers(mat.productId, mat.preferredSupplierId, mat.supplierIds);
    })),
    supplierIds: builder.listOf(builder.str('supplierIds')),
    supplierGroups: builder.listOf(builder.obj('supplierGroups', ProductSuppliersGroup_1.ProductSuppliersGroup.schema, function (mat) {
      return new ProductSuppliersGroup_1.ProductSuppliersGroup(mat.productId, mat.supplierIds);
    }))
  };
}();